import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';

import { selectorLogin } from '../../selectors/selector_login';

const getDisplayName = (WrappedComponent) => {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

const SeguretatWrapper = (ComponentSenseSeguretat, esPotRenderitzarComponent) => class extends Component {

    static displayName = `WrapperSeguretat(${getDisplayName(ComponentSenseSeguretat)})`;

    render() {
        const { idUsuari, idRol, dispatch, ...propsFill } = this.props;

        if (esPotRenderitzarComponent(idUsuari, idRol)) {
            return <ComponentSenseSeguretat {...propsFill} />;
        }

        return null;
    }
};

SeguretatWrapper.propTypes = {
    idUsuari: PropTypes.number,
    idRol: PropTypes.number
};

const mapStateToProps = (state) => {
    return selectorLogin(state);
};

//http://es.redux.js.org/docs/api/compose.html
const SeguretatWrapperHOC = compose(connect(mapStateToProps), SeguretatWrapper);
export default SeguretatWrapperHOC;



// WEBPACK FOOTER //
// ./src/components/seguretat/seguretatWrapper.js